// extracted by mini-css-extract-plugin
export default {"tabsHeaderContainer":"Hf1xtg","tabsContainer":"qWQSsA","tabs":"SJoVBY","icon":"fop8I8","indicator":"nFwCaY","description":"X1GxQD","tab":"S7B2K_","tabTitle":"sDMajE"};